import { render, staticRenderFns } from "./LabReportTable.vue?vue&type=template&id=2daee814&scoped=true&lang=html&"
import script from "./LabReportTable.vue?vue&type=script&lang=js&"
export * from "./LabReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daee814",
  null
  
)

export default component.exports